import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";
import { productionLogger } from '@/utils/production-logger';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
    
    // Track page view automatically handled by analytics system
  }, [pathname, analytics]);

  return null;
};

export default ScrollToTop;